export const columns = [
  {
    title: <span data-testid="source-title">Источник</span>,
    dataIndex: 'migration',
    key: 'migration',
  },
  {
    title: <span data-testid="user-title">Пользователь</span>,
    dataIndex: 'user',
    key: 'user',
  },
  {
    title: <span data-testid="status-title">Статус</span>,
    dataIndex: 'status',
    key: 'status',
  },
  {
    title: '',
    dataIndex: 'actions',
    key: 'actions',
    width: 80,
  },
];
